import React from "react";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import OnboardingRadioButton from "../shared/components/formik/radiobutton";
import { useMessageSource } from "react-message-source";
import { ControllerIdentification } from "../../api/commercial/generated-types";
import CustomTypography from "../../ui/widgets/typography";

export const ControllerIdentificationComponent: React.FC = () => {
  const { getMessage } = useMessageSource();

  return (
    <>
      <CustomTypography variant="h3">
        {getMessage("RegulatoryInformation.controller-identification.title")}
      </CustomTypography>
      <RadioButtonContainer>
        <OnboardingRadioButton
          title={getMessage(
            "RegulatoryInformation.controller-identification.sub-title",
          )}
          id={"controllerIdentification"}
          name={"controllerIdentification"}
          values={[
            {
              id: "SHARES" as ControllerIdentification,
              value: "SHARES" as ControllerIdentification,
              label: getMessage(
                "RegulatoryInformation.controller-identification.SHARES",
              ),
            },
            {
              id: "OTHER" as ControllerIdentification,
              value: "OTHER" as ControllerIdentification,
              label: getMessage(
                "RegulatoryInformation.controller-identification.OTHER",
              ),
            },
            {
              id: "DIRECTOR" as ControllerIdentification,
              value: "DIRECTOR" as ControllerIdentification,
              label: getMessage(
                "RegulatoryInformation.controller-identification.DIRECTOR",
              ),
            },
          ]}
        />
      </RadioButtonContainer>
    </>
  );
};
